<template>
    <v-container fluid class="pt-0">
        <v-card class="px-5 py-3 br-15 w-100" elevation="0">
            <v-row>
                <v-col class="flex-grow-1">
                    <v-toolbar-title class="page-title"
                        >Lançamentos</v-toolbar-title
                    >
                </v-col>

                <div class="d-flex py-3 px-4">
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                color="primary"
                                class="new-button px-8"
                                dark
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon left>mdi-microsoft-excel</v-icon>
                                Exportar
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item @click="exportar()">
                                <v-list-item-title>Listagem</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="exportar('remarcacao')">
                                <v-list-item-title>Dados Remarcação</v-list-item-title>
                            </v-list-item>

                        </v-list>
                    </v-menu>
                </div>
            </v-row>
            <filtro ref="filtro" @filtrar="filtrar" @limpar="limpar"></filtro>
        </v-card>

        <v-card class="px-5 py-5 br-15 w-100 mt-5" elevation="0">
            <v-data-table
                class="elevation-0 tabela"
                :headers="headerListagem"
                :items="dados"
                :items-per-page="10"
                :footer-props="tableConfig"
                :header-props="{ sortIcon: 'mdi-chevron-down' }"
                item-key="id_planejamento"
                multi-sort
            >
                <template v-slot:[`item.data_criacao`]="{ item }">
                    {{
                        $moment(item.data_criacao).format('DD/MM/YYYY HH:mm:ss')
                    }}
                </template>
                <template v-slot:[`item.investimento`]="{ item }">
                    {{ formataReal(item.investimento) }}
                </template>
                <template v-slot:[`item.mes`]="{ item }">
                    {{ $moment(item.mes).format('MMMM [de] YYYY') }}
                </template>
                <template v-slot:[`item.data_inicio`]="{ item }">
                    {{ $moment(item.data_inicio).format('DD/MM/YYYY') }}
                </template>
                <template v-slot:[`item.data_fim`]="{ item }">
                    {{ $moment(item.data_fim).format('DD/MM/YYYY') }}
                </template>
                <template v-slot:[`item.semana`]="{ item }">
                    Semana {{ item.semana }}
                </template>
                <template v-slot:[`item.projeto`]="{ item }">
                    <v-tooltip top v-if="item.projeto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                depressed
                                v-bind="attrs"
                                v-on="on"
                                @click="copyURL(item.projeto)"
                            >
                                {{
                                    item.projeto
                                        ? item.projeto.substr(0, 20) + '...'
                                        : ''
                                }}
                            </v-btn>
                        </template>
                        <span>{{ item.projeto }}</span>
                    </v-tooltip>
                    <span v-else>{{ item.projeto }}</span>
                </template>
                <template v-slot:[`item.link`]="{ item }">
                    <v-tooltip top v-if="item.link">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                depressed
                                color="default"
                                v-bind="attrs"
                                v-on="on"
                                @click="copyURL(item.link)"
                            >
                                {{
                                    item.link
                                        ? item.link.substr(0, 20) + '...'
                                        : ''
                                }}
                            </v-btn>
                        </template>
                        <span>{{ item.link }}</span>
                    </v-tooltip>
                    <span v-else>{{ item.link }}</span>
                </template>
            </v-data-table>
        </v-card>
        <v-overlay :value="carregando" :z-index="300">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
</template>

<script>
import Filtro from '../Filtro.vue'
import { mapActions } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import useFiltros from '@/hooks/useFiltros'
export default {
    name: 'lancamentosFornecedor',
    components: {
        Filtro,
    },
    setup() {
        const { isLoading, isError, isFetching, data, error, refetch } =
            useFiltros('/planejamentoEcommerce/listaCampos')
        return {
            isLoading,
            isError,
            isFetching,
            lista: data,
            error,
            refetch,
        }
    },
    data() {
        return {
            timerFiltroInicial: null,
            menuProps: {
                bottom: true,
                offsetY: true,
                contentClass: 'select-outline',
                transition: 'slide-y-transition',
            },

            carregando: false,

            tableConfig: {
                itemsPerPageOptions: [5, 10, 20, 50, 100, -1],
                itemsPerPageText: 'Linhas por páginas',
                ofText: 'de',
                pageText: '{0}-{1} de {2}',
            },

            dados: [],
            regra: {},
            headerListagem: [],
        }
    },

    computed: {
        ...mapFields('planejamento_ecommerce', [
            'filtro.periodoInicial',
            'filtro.periodoFinal',
            'filtro.tipoPeriodo',
            'filtro.id_bandeira',
            'filtro.id_planejamento',
            'filtro.semana',
            'filtro.id_ativacao',
            'filtro.device',
            'filtro.id_area',
            'filtro.id_fornecedor',
            'filtro.id_categoria',
            'filtro.plano',
            'filtro.id_status_planejamento',
            'filtro.ativacao',
            'filtro.id_macrofornecedor',
            'filtro.acao',
        ]),
    },
    methods: {
        ...mapActions('planejamento_ecommerce', ['limparFiltro', 'saveCache']),
        limpar() {
            this.limparFiltro()
            this.filtrar()
        },
        async exportar(tipo = 'listagem') {
            this.headerListagemMonte()
            if (!this.$refs.filtro.validate()) return

            this.carregando = true

            const data = {
                periodoInicial: this.periodoInicial,
                periodoFinal: this.periodoFinal,
                tipoPeriodo: this.tipoPeriodo,
                id_bandeira: this.id_bandeira,
                semana: this.semana,
                id_ativacao: this.id_ativacao,
                device: this.device,
                id_area: this.id_area,
                id_fornecedor: this.id_fornecedor,
                id_categoria: this.id_categoria,
                plano: this.plano,
                id_status_planejamento: this.id_status_planejamento
                    ? this.id_status_planejamento
                    : [],
                ativacao: this.ativacao,
                id_macrofornecedor: this.id_macrofornecedor,
                acao: this.acao,
                id_planejamento: this.id_planejamento
                    ? [this.id_planejamento]
                    : [],
                planejamento_fornecedor: [1],
                tipo: tipo,
            }
            data.data_inicio = this.periodoInicial
            data.data_fim = this.periodoFinal

            // data.pagination = this.pagination;
            data.busca = this.busca

            data.planograma = this.planograma
            data.statusIndicadores = this.statusIndicadores

            if (data.acao && data.acao.length > 0) {
                data.acao = [data.acao]
            }



            const response = await this.$http().post(
               '/planejamentoEcommerce/exportar',
                { data }
            )
            this.carregando = false;
            if (response.status == 200) {
                this.$dialog.notify.success('Exportação realizada com sucesso!')
                window.location = this.$http('baseURL') + response.data.url
            } else {
                this.$dialog.notify.error(
                    response.data.mensagem || 'Erro ao exportar Exportação!'
                )
            }
        },
        formataReal(valor) {
            return Number(valor).toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL',
            })
        },
        headerListagemMonte() {
            const filtro = this.$refs.filtro
            if (!this.lista.campos) return false

            let ativacao = 'default'
            if (this.ativacao) {
                ativacao = this.ativacao[0]
            }

            let campos
            if (ativacao && this.lista?.campos[ativacao]) {
                campos = this.lista.campos[ativacao]
            } else {
                campos = this.lista.campos['default']
            }
            const camposFinal = campos
                .filter((item) => !(item?.ocultarListagem || false))
                .map((item) => {
                    return {
                        text: item.nome,
                        value: item.campo,
                        align: 'center',
                        class: 'th-separador',
                        width: '100px',
                    }
                })
            this.headerListagem = [...camposFinal]
        },

        async filtrar() {
            this.headerListagemMonte()
            if (!this.$refs.filtro.validate()) return

            this.carregando = true

            const data = {
                periodoInicial: this.periodoInicial,
                periodoFinal: this.periodoFinal,
                tipoPeriodo: this.tipoPeriodo,
                id_bandeira: this.id_bandeira,
                semana: this.semana,
                id_ativacao: this.id_ativacao,
                device: this.device,
                id_area: this.id_area,
                id_fornecedor: this.id_fornecedor,
                id_categoria: this.id_categoria,
                plano: this.plano,
                id_status_planejamento: this.id_status_planejamento
                    ? this.id_status_planejamento
                    : [],
                ativacao: this.ativacao,
                id_macrofornecedor: this.id_macrofornecedor,
                acao: this.acao,
                id_planejamento: this.id_planejamento
                    ? [this.id_planejamento]
                    : [],
                planejamento_fornecedor: [1],
            }
            data.data_inicio = this.periodoInicial
            data.data_fim = this.periodoFinal

            // data.pagination = this.pagination;
            data.busca = this.busca

            data.planograma = this.planograma
            data.statusIndicadores = this.statusIndicadores

            if (data.acao && data.acao.length > 0) {
                data.acao = [data.acao]
            }

            const response = await this.$http().post(
                '/planejamentoEcommerce/lista',
                {
                    data: data,
                }
            )
            if (response.status == 200 && response.data.data) {
                const { planejamentos, indicadores } = response.data.data
                this.dados = planejamentos
                this.indicadores = indicadores

                // this.pagination.total = response.data.data.total;
            }
            this.saveCache()
            this.carregando = false
        },
    },
    mounted() {
        //  this.carregando = true
        //   this.filtrar()
        //    var self = this;
        this.timerFiltroInicial = setTimeout(() => this.filtrar(), 3000)
        //     this.carregando = false
    },
    beforeDestroy() {
        clearTimeout(this.timerFiltroInicial)
    },
}
</script>
